import { render, staticRenderFns } from "./IngredientUnitListView.vue?vue&type=template&id=10f39072&scoped=true"
import script from "./IngredientUnitListView.vue?vue&type=script&lang=js"
export * from "./IngredientUnitListView.vue?vue&type=script&lang=js"
import style0 from "./IngredientUnitListView.vue?vue&type=style&index=0&id=10f39072&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f39072",
  null
  
)

export default component.exports